import type { IFrontendEnvironment } from './IFrontendEnvironment';

const regex = /stage\.branch|localhost/;

export class FrontendEnvironment implements IFrontendEnvironment {
  constructor(private window: Window) {}

  private isContextProduction = () => this.window?.App?.context?.environment === 'production';

  private isHostStaging = (host) => regex.test(host);

  private isContextUndefinedAndNotStaging = (host) => !this.window?.App?.context?.environment && !this.isHostStaging(host);

  public isProduction(): boolean {
    const host = this.window?.location?.host;

    let isProd = false;

    if (this.isContextProduction()) {
      isProd = true;
    }

    if (isProd) {
      isProd = !this.isHostStaging(host);
    }

    if (this.isContextUndefinedAndNotStaging(host)) {
      isProd = true;
    }

    return isProd;
  }
}
